import * as React from "react";
import { HorizontalSpacer } from "../atoms/Spacers";
import { theme } from "../../theme";
import Body from "../atoms/typography/Body";
import { Row } from "react-grid-system";
import { useTranslation } from "react-i18next";
import Subtitle from "../atoms/typography/Subtitle";
import { HelloManIllustration } from "../atoms/illustrations/HelloManIllustration";

interface Props {
  message?: string;
}

const NoContentView: React.FC<Props> = ({ message }) => {
  const { t } = useTranslation();
  return (
    <div>
      <HorizontalSpacer spacing={2} />
      <Subtitle color={theme.colors.primary} textalign="center">
        {t("random.noContent")}
      </Subtitle>
      <HorizontalSpacer spacing={0.5} />
      <Body textalign="center" color={theme.colors.primary}>
        {message}
      </Body>
      <HorizontalSpacer spacing={2} />
      <Row justify="center">
        <HelloManIllustration />
      </Row>
    </div>
  );
};

export default NoContentView;
